import { render, staticRenderFns } from "./BaseButtonIcon.vue?vue&type=template&id=5f47f31c&scoped=true"
import script from "./BaseButtonIcon.vue?vue&type=script&lang=js"
export * from "./BaseButtonIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f47f31c",
  null
  
)

export default component.exports